import { Flame, Sparkles, Dices } from 'lucide-react'
import type { SlotType } from '../../lib/types'
import { Badge, Tooltip } from '../ui'

interface SlotBadgeProps {
  slotType: SlotType
  isExploration?: boolean
}

/**
 * Slot badges are driven by `slot_type` (route map §4). Exploration picks are
 * labeled distinctly ("a little different") so users understand an unusual pick
 * — never hidden or re-sorted to the bottom (skill guardrail #4). Each badge
 * carries a Tooltip explaining why its slot exists (DS voice — §5.2); the same
 * explanation rides inline as sr-only text because badges are not focusable,
 * so the hover-only tooltip never reaches keyboard/SR users.
 */
export function SlotBadge({ slotType, isExploration }: SlotBadgeProps) {
  if (slotType === 'primary') {
    return (
      <Tooltip content="Tonight's pick — the strongest fit for everyone in the roster">
        <Badge variant="ember" icon={<Flame className="h-3.5 w-3.5" strokeWidth={2} />}>
          Tonight&apos;s pick
          <span className="sr-only">{' — the strongest fit for everyone in the roster'}</span>
        </Badge>
      </Tooltip>
    )
  }
  if (slotType === 'spotlight') {
    return (
      <Tooltip content="Indie spotlight — a niche gem the group's taste points at">
        <Badge variant="info" icon={<Sparkles className="h-3.5 w-3.5" strokeWidth={2} />}>
          Indie spotlight
          <span className="sr-only">{' — a niche gem the group’s taste points at'}</span>
        </Badge>
      </Tooltip>
    )
  }
  // wildcard
  return (
    <Tooltip content="Wildcard — deliberate exploration outside the group's usual lanes">
      <Badge variant="warning" icon={<Dices className="h-3.5 w-3.5" strokeWidth={2} />}>
        {isExploration ? 'Wildcard · a little different' : 'Wildcard'}
        <span className="sr-only">{' — deliberate exploration outside the group’s usual lanes'}</span>
      </Badge>
    </Tooltip>
  )
}
